import { ADDRESSES, etherscanUrl, type ContractName } from '../../lib/sepoliaLive';

interface Props {
  name: ContractName;
}

export default function ContractRef({ name }: Props) {
  const address = ADDRESSES[name];
  return (
    <a
      href={etherscanUrl(name)}
      target="_blank"
      rel="noreferrer"
      className="contract-ref"
      title={address}
    >
      <code>{name}</code>
      <span className="contract-ref-addr">{address.slice(0, 6)}…{address.slice(-4)}</span>
      <style>{css}</style>
    </a>
  );
}

const css = `
.contract-ref {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 2px 8px;
  background: var(--c-bg-alt);
  border: 1px solid var(--c-border);
  border-radius: var(--radius-sm);
  font-size: 0.85em;
  text-decoration: none;
}
.contract-ref:hover { border-color: var(--c-accent); text-decoration: none; }
.contract-ref-addr {
  font-family: var(--font-mono);
  color: var(--c-muted);
  font-size: 0.9em;
}
`;
